export default {"src":"/_next/static/media/paypal-white.4c5125b0.svg","height":20,"width":77,"blurWidth":0,"blurHeight":0};